// extracted by mini-css-extract-plugin
export default {"DragHandlerWrapper":"_DragHandlerWrapper--O5bY_","Center":"_Center--I28dR","IconWrapper":"_IconWrapper--eeDhw","Icon":"_Icon--pnG4m"};